export default __webpack_public_path__ + "7980bca38af513c70801c085bbb320a8.png";